import { useContext } from 'react';
import { AuthContext } from '~/contexts';
import { AuthContextData } from '~/contexts/AuthContext/types';

export function useAuth(): AuthContextData {
  const context = useContext(AuthContext);
  return context;
}
